import Button from "@ingka/button";
import styled from "styled-components";

export const Wrapper = styled.div`
  display: grid;
  position: relative;
  row-gap: var(--space-200);
  ${({ theme }) => `${theme.breakpoints.lg} {
    row-gap: unset;
    grid-template-columns: 1fr 1fr;
    column-gap: var(--space-250);
  }`}
`;

export const EventPriceAmount = styled.p<{ isFree: boolean }>`
  font-size: var(--font-size-100);
  margin: var(--space-150) 0;
  &:not(:last-of-type) {
    margin-bottom: ${({ isFree }) => isFree && "var(--space-200)"};
  }

  ${({ theme }) => `${theme.breakpoints.lg} {
    font-size: var(--font-size-500);
    margin-top: var(--space-150);
  }`}
`;

export const EventPriceNote = styled.p`
  margin: 0;
  font-size: var(--font-size-50);
  font-style: italic;
  &:not(:last-of-type) {
    margin-bottom: var(--space-200);
  }
`;

export const EventLocation = styled.p`
  margin-top: var(--space-200);

  ${({ theme }) => `${theme.breakpoints.lg} {
    margin-top: var(--space-300);
  }`}
`;

export const NoRegistrationRequired = styled.p`
  margin-bottom: var(--space-100);
`;

export const EventName = styled.h1`
  margin-bottom: var(--space-100);

  ${({ theme }) => `${theme.breakpoints.lg} {
    margin-bottom: var(--space-150);
  }`}
`;

export const RegisterButton = styled(Button)`
  margin: var(--space-200) 0;
  width: 100%;
  ${({ theme }) => `${theme.breakpoints.lg} {
    margin: var(--space-300) 0;
    width: auto;
  }`}
`;

export const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #ffffff70;
  z-index: 2;
`;

export const EventDescription = styled.p`
  white-space: break-spaces;
`;

export const DigitalEventWrapper = styled.div`
  margin: var(--space-300) 0 0;
`;

export const GotoDigitalEventWrapper = styled.div`
  margin: var(--space-300) 0 0;
`;
